import { DummyServiceCaller } from "./dummy";
import { RosLibJsServiceCaller, RosLibJsServiceOptions } from "./roslibjs";
import {
  WebRosProxyServiceCaller,
  WebRosProxyServiceOptions,
} from "./webrosproxy";
import { FoxgloveServiceCaller, FoxgloveServiceOptions } from "./foxglove";

export const ServiceSources = {
  WEBROSPROXY: WebRosProxyServiceCaller,
  ROSLIBJS: RosLibJsServiceCaller,
  FOXGLOVE: FoxgloveServiceCaller,
  DUMMY: DummyServiceCaller,
};

type MakeServiceCallerFn = {
  (
    type: "WEBROSPROXY",
    options: WebRosProxyServiceOptions
  ): WebRosProxyServiceCaller;
  (type: "ROSLIBJS", options: RosLibJsServiceOptions): RosLibJsServiceCaller;
  (type: "FOXGLOVE", options: FoxgloveServiceOptions): FoxgloveServiceCaller;
  (
    type: "DUMMY",
    options: ConstructorParameters<typeof DummyServiceCaller>
  ): DummyServiceCaller;
};

export const makeServiceCaller: MakeServiceCallerFn = (type, options): any => {
  switch (type) {
    case "WEBROSPROXY":
      return new WebRosProxyServiceCaller(options as WebRosProxyServiceOptions);
    case "ROSLIBJS":
      return new RosLibJsServiceCaller(options as RosLibJsServiceOptions);
    case "FOXGLOVE":
      return new FoxgloveServiceCaller(options as FoxgloveServiceOptions);
    case "DUMMY":
      console.log("dummy got options:", options);
      return new DummyServiceCaller(
        ...(options as ConstructorParameters<typeof DummyServiceCaller>)
      );
    default:
      throw new Error(
        `Unable to make service instance because of invalid service type ${type}. Must be one of ${Object.keys(
          ServiceSources
        )}`
      );
  }
};
